const LoadingScreen = () => {
  return (
    <div className='fixed top-0 left-0 right-0 bottom-0 bg-blue-500 flex flex-col items-center justify-center'>
      <div className='lds-ripple mt-[-100px]'>
        <div></div>
        <div></div>
      </div>
      <div className='p-4 bg-white rounded-full shadow-xl'>
        <img src='/img/logo.png' alt='ECL' className='md:w-40 w-28' />
      </div>
    </div>
  );
};

export default LoadingScreen;
